import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Dropdown, Form, InputGroup} from 'react-bootstrap';
import SvgIcon from "../../../../../components/svg-icon";
import {useSelector} from "react-redux";
import associateServices from "../../../../../services";
import TryProvidersModal from "./try-providers-modal";
import TryMethodsModal from "./try-methods-modal";
import StringHelper from "../../../../../helpers/string-helper";

// const depositTypes = ['Fast EFT', 'Papara', 'Credit Card', 'FixTurka(PayFix)']

const TryPaymentMethodDropdown = ({tryPaymentMethod, handleMethod}) => {

    const {t} = useTranslation()
    const [methods, setMethods] = useState([])
    const [tryPaymentMethodLocal, setTryPaymentMethodLocal] = useState('')
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [providers, setProviders] = useState([])


    useEffect(() => {
        associateServices.getPaymentMethods({
            type: 'deposit',
            currency:'TRY'

        }).then(res => setMethods(res?.data))
    }, [])

    useEffect(() => {
        if (tryPaymentMethodLocal) {
            associateServices.getPaymentProviders({
                method: tryPaymentMethodLocal,
                type: 'deposit',
                currency:'TRY'
            }).then(res => {
                setProviders(res?.data)
            })
        }
    }, [tryPaymentMethodLocal])


    useEffect(() => {
        setShowModal(false)
        setShow(false)
    }, [tryPaymentMethod])

    const handleMethod1 = (selectedMethod) => {
        setTryPaymentMethodLocal(selectedMethod?.parent)
        setShow(false)
        setShowModal(true)
    }
    return (
        <>


            <TryMethodsModal show={show} setShow={setShow} methods={methods}
                             handleMethod={handleMethod1}/>


            <TryProvidersModal show={showModal} setShow={setShowModal} providers={providers}
                               handleMethod={handleMethod}/>


            <div
                className="modal__wallet-dropdown modal__wallet-dropdown--double-big"
            >
                <div
                    className="modal__wallet-dropdown-btn"
                    id="modalWallet0"
                    aria-expanded={show}
                    onClick={() => setShow(!show)}
                >
                    {tryPaymentMethod ? t(`general.${StringHelper.slugify(tryPaymentMethod)}`, tryPaymentMethod) : t('general.select-payment-method', 'Payment Method')}


                    <SvgIcon id={'right-down'}/>
                </div>


            </div>
        </>

    )

}


export default TryPaymentMethodDropdown
